import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { MdDelete } from "react-icons/md";
import { ImFolderUpload } from "react-icons/im";
import useAttachments from "@/features/attachments/hooks/useAttachments";
import { getAttachmentUrlById } from "@/features/attachments/services/attachmentService";
const ChargeAttachmentUploader = ({ attachments, onChange }) => {
    const { handleAddAttachment, handleDeleteAttachment, handleDownloadAttachment } = useAttachments();
    const handleFileUpload = async (event) => {
        if (!event.target.files)
            return;
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("attachment", file);
        try {
            const newAttachment = await handleAddAttachment(formData);
            onChange([...attachments, newAttachment].filter(Boolean));
        }
        catch (error) {
            console.error("Erreur upload", error);
        }
    };
    const handleRemove = useCallback(async (id) => {
        await handleDeleteAttachment(id);
        onChange(attachments.filter((att) => att.id !== id));
    }, [attachments, onChange, handleDeleteAttachment]);
    const downloadFile = (id) => {
        if (!id)
            return;
        const url = getAttachmentUrlById(id);
        const link = document.createElement("a");
        link.href = url;
        link.rel = "noopener";
        link.click();
    };
    return (_jsxs("div", { className: "space-y-2", children: [_jsxs("div", { className: "flex gap-2 justify-center items-center", children: [_jsx("label", { htmlFor: "file-upload", className: "cursor-pointer text-blue-500 flex items-center gap-2", children: _jsx(ImFolderUpload, { title: "Ajouter un justificatif" }) }), _jsx("input", { id: "file-upload", type: "file", className: "hidden", onChange: handleFileUpload })] }), _jsx("ul", { className: "list-disc pl-4 text-sm", children: attachments.map((file) => (_jsxs("li", { className: "flex justify-between items-center", children: [_jsx("span", { title: file.file_name, children: _jsx("a", { className: "text-blue-700", href: "#", onClick: () => downloadFile(file.id), children: file.file_name ? file.file_name.length > 15 ? `${file.file_name.slice(0, 15)}...` : file.file_name : "" }) }), _jsx("button", { type: "button", onClick: () => handleRemove(file.id), className: "text-red-500", children: _jsx(MdDelete, {}) })] }, file.id))) })] }));
};
export default ChargeAttachmentUploader;
